import _ from 'lodash'
export function isUnauthenticatedError (error) {
  const err = _.get(error, 'response.status')
  return err === 401
}
